import {
  Directive,
  HostBinding,
  Inject,
  INJECTOR,
  Injector,
  Input,
  isDevMode,
  OnDestroy,
  OnInit,
  Optional,
} from '@angular/core';
import { FormDefinition, RxapFormArray } from 'eurogard-forms';
import { OpenFormWindowMethodDirective } from 'eurogard-form-window-system';
import { ControlContainer } from '@angular/forms';
import { WindowRef } from 'eurogard-window-system';
import '@rxap/rxjs';
import { Method } from 'eurogard-pattern';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[rxapFormAddItem]',
  standalone: true,
})
export class FormAddItemDirective<FormData extends Record<string, any>>
  extends OpenFormWindowMethodDirective<FormData>
  implements OnDestroy, OnInit {

  @HostBinding('attr.type')
  @Input()
  public type = 'button';

  @Input({
    alias: 'rxapFormAddItem',
    required: true,
  })
  public declare method: Method<WindowRef<FormDefinition, FormData>, Partial<FormData>>;

  constructor(
    private readonly parent: ControlContainer,
    @Optional()
    @Inject(INJECTOR)
      injector: Injector | null = null,
  ) {
    super(injector);
  }

  public ngOnInit() {
    if (isDevMode()) {
      console.log('form-add-item', this.parent);
    }
  }

  protected override submitted(value: FormData) {
    super.submitted(value);
    this.addItem(value);
  }

  private addItem(value: FormData) {
    const control = this.parent.control;
    if (control) {
      if (control instanceof RxapFormArray) {
        control.insertAt(0, value);
      }
    } else {
      if (isDevMode()) {
        console.warn('The parent control container');
      }
    }
  }

}


